<div class="container">
  <mat-tab-group
    (selectedIndexChange)="tabChange($event)"
    headerPosition="above"
    class="mat-tab-group mat-primary ng-star-inserted"
  >
    <mat-tab
      label="{{ 'dashboard.overview-table.manure-offers-button' | translate }} ({{
        totalNumberOfOffers$ | async
      }})"
      class="mat-tab-header"
    >
      <div
        aria-hidden="true"
        mat-ripple
        class="mat-ripple mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4 mat-tab-header-pagination-disabled"
      >
        <div class="mat-tab-header-pagination-chevron"></div>
      </div>
    </mat-tab>
    <mat-tab
      label="{{ 'dashboard.overview-table.manure-requests-button' | translate }} ({{
        totalNumberOfRequests$ | async
      }})"
      class="mat-tab-header"
    >
      <div
        aria-hidden="true"
        mat-ripple
        class="mat-ripple mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4 mat-tab-header-pagination-disabled"
      >
        <div class="mat-tab-header-pagination-chevron"></div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
